import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFreelancers } from '../../Apis/index';

export const FreelancerFind = createAsyncThunk('projectpost', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await getFreelancers(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

const freelancerSlice = createSlice({
    name: 'empFreelancer',
    initialState: {
        error: null,
        success: false,
        data: [],
        error1: null,
        success1: false,
    },
    reducers: {
        clearEmpFreelancerStatus: state => {
            state.success = false;
            state.error = null;
            state.error1 = null;
            state.success1 = false;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(FreelancerFind.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(FreelancerFind.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(FreelancerFind.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })

    },

});
export const { clearEmpFreelancerStatus } = freelancerSlice.actions;
export default freelancerSlice.reducer;

